import React, { useState, useEffect } from 'react';
import IconSkeleton from './IconSkeleton';
import styles from './ImageWithSkeleton.module.css';
import { useSelector } from 'react-redux';

const ImageWithSkeleton = ({
    src,
    alt = '',
    className = '',
    skeletonWidth = '100px',
    skeletonHeight = '50px',
    skeletonShape = 'square', // 'square', 'rounded', 'circle'
    onLoad,
    onError,
    fallbackSrc,
    ...props
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [currentSrc, setCurrentSrc] = useState(src);
    const isOpen = useSelector(state => state.sidebar.isActive);
  

    // Сбрасываем состояние загрузки при изменении src
    useEffect(() => {
        if (src !== currentSrc) {
            setIsLoading(true);
            setHasError(false);
            setCurrentSrc(src);
        }
    }, [src, currentSrc]);

    const handleLoad = (e) => {
        setIsLoading(false);
        setHasError(false);
        if (onLoad) onLoad(e);
    };

    const handleError = (e) => {
        setIsLoading(false);
        setHasError(true);

        // Если есть fallback изображение, пробуем его
        if (fallbackSrc && src !== fallbackSrc) {
            setCurrentSrc(fallbackSrc);
            setIsLoading(true);
            setHasError(false);
        } else {
            if (onError) onError(e);
        }
    };

    return (
        <div className={[styles.container, isOpen && styles.active, className].filter(Boolean).join(' ')}>
            <img
                src={currentSrc}
                alt={alt}
                className={`${styles.image} ${isLoading ? styles.hidden : styles.visible}`}
                onLoad={handleLoad}
                onError={handleError}
                {...props}
            />
            <IconSkeleton
                width={skeletonWidth}
                height={skeletonHeight}
                show={isLoading}
                className={`${styles.skeleton} ${styles[skeletonShape]}`}
            />
        </div>
    );
};

export default ImageWithSkeleton;
